module.exports = __webpack_public_path__ + "img/cbc_colorlogo.9145c84.png";